<template>
  <div class="skeleton-grid">
    <v-skeleton-loader
      v-for="n in skeletonCount"
      :key="n"
      class="custom-skeleton"
      type="image, list-item-two-line, button"
    ></v-skeleton-loader>
  </div>
</template>

<script>
export default {
  computed: {
    skeletonCount() {
      // Show 12 skeletons to match the itemsPerPage in Products.vue
      return 12;
    },
  },
};
</script>

<style scoped lang="scss">
.skeleton-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(390px, 1fr));
  gap: 20px;
  grid-auto-rows: 1fr;
}

.custom-skeleton {
  width: 100%;
  height: 100%;
  min-height: 400px; // Adjust based on your actual product card height
}

.custom-skeleton ::v-deep .v-skeleton-loader__button {
  margin-left: 0 !important;
  margin-right: auto !important;
}

// Match the responsive breakpoints from Products.vue
.isTablet {
  .skeleton-grid {
    grid-template-columns: repeat(auto-fill, minmax(500px, 1fr)) !important;
  }
}

.isTablet,
.isMobile {
  .skeleton-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
